module.exports = __webpack_public_path__ + "img/lbc.8758f815.svg";